import React, { FunctionComponent } from 'react'

import { BaseButton, BaseButtonProps, ButtonType } from '../baseButton/BaseButton'

export type SecondaryIconButtonProps = Omit<BaseButtonProps, 'rightIcon' | 'buttonType' | 'text'> & {
  isSurvey?: boolean
}

export const SecondaryIconButton: FunctionComponent<SecondaryIconButtonProps> = (props) => {
  return <BaseButton buttonType={props.isSurvey ? ButtonType.SURVEY_ICON : ButtonType.SECONDARY_ICON} {...props} />
}
